var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 align-start fill-height ma-0",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"zoom","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }